// src/components/common/QrScannerModal.js

import React, { useRef, useEffect } from 'react';

export default function QrScannerModal({ onClose, onScanSuccess }) {
    const scannerRef = useRef(null);

    useEffect(() => {
        if (window.Html5QrcodeScanner) {
            const scanner = new window.Html5QrcodeScanner(
                "qr-reader", 
                { fps: 10, qrbox: 250 },
                false
            );
            
            const success = (decodedText, decodedResult) => {
                scanner.clear();
                onScanSuccess(decodedText);
            };

            const error = (err) => {
                // console.warn(err);
            };

            scanner.render(success, error);
            scannerRef.current = scanner;
        }

        return () => {
            if (scannerRef.current) {
                scannerRef.current.clear();
            }
        };
    }, [onScanSuccess]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex flex-col justify-center items-center z-50 p-4">
            <div className="bg-slate-800 p-6 rounded-lg shadow-2xl w-full max-w-md">
                <div id="qr-reader" className="w-full"></div>
                <button onClick={onClose} className="mt-4 w-full bg-slate-600 hover:bg-slate-500 text-white font-bold py-2 px-4 rounded-md transition-colors">
                    Cancelar
                </button>
            </div>
        </div>
    );
}